import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { sharedImage } from "@/lib/images";
import content from "@/data/content/experiences.json";

const MARQUEE = content.marquee;
const EXP_IMG = sharedImage(content.image);

export const Experiences = () => {
  return (
    <section
      id="experiences"
      data-testid="experiences-section"
      className="scroll-mt-24 relative overflow-hidden bg-brown text-ivory"
    >
      {/* Slow editorial marquee */}
      <div className="py-6 border-y border-ivory/10 overflow-hidden">
        <div className="flex whitespace-nowrap animate-marquee">
          {[...MARQUEE, ...MARQUEE].map((item, i) => (
            <span
              key={i}
              className="mx-8 font-serif text-2xl md:text-3xl text-ivory/40 italic"
            >
              {item} <span className="text-gold not-italic mx-2">·</span>
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20 grid gap-12 md:grid-cols-2 items-center">
        <div>
          <Reveal>
            <span className="inline-flex items-center rounded-full bg-terracotta px-4 py-1.5 text-xs font-medium uppercase tracking-wider text-white">
              {content.badge}
            </span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif text-4xl md:text-5xl font-semibold">
              {content.title}
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-5 text-ivory/75 leading-relaxed max-w-md">
              {content.body}
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.2}>
          <motion.div
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.5 }}
            className="relative rounded-2xl overflow-hidden aspect-[4/3] shadow-2xl"
          >
            <img
              src={EXP_IMG}
              alt={content.imageAlt}
              loading="lazy"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-brown/20" />
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
};

export default Experiences;
